module.exports = __webpack_public_path__ + "static/media/explore_col_3.f512fd1f.svg";